<template>
    <div class="blurCapFeed">
        <BlurCapImage class="blurCapItem"
            v-for="(entry, index) in entries"
            :key="index"
            :routerLink="'/entry/' + entry.id"
            :carousel="entry.media.carousel"
            :image="image(index)"
            :slider="slider(index)"
            :position="position(index)"
            :badgeLabel="siteContent.featured"
            :badgeType="badgeType(index)"
            :sensitive="sensitive(index)"
            badgeIcon="magic_button"
            orientation="portrait">
                <EntryDetail
                    :entry="entry"
                    @openLikedBy="updateUserList"/>
        </BlurCapImage>
    </div>
</template>

<script>
    import EntryDetail from '@/components/journal/main/EntryDetail'

    export default {
        name: 'PostFeed',
        components: {
            EntryDetail
        },
        data() {
            return {
                userListDialog: false,
                userList: []
            }
        },
        props: {
            entries: {
                type: Array,
                required: true
            }
        },
        methods: {
            badgeType(i) {
                if(this.entries[i].flag.featured) {
                    return 'featured'
                }
            },
            image(i) {
                if(this.entries[i].media.carousel) {
                    return this.entries[i].media.carousel[0].url
                } else if(this.entries[i].media.slider) {
                    return this.entries[i].media.slider.right.url
                } else {
                    return
                }
            },
            position(i) {
                if(this.entries[i].media.carousel) {
                    return this.entries[i].media.carousel[0].position
                } else if(this.entries[i].media.slider) {
                    return this.entries[i].media.slider.left.position
                } else {
                    return
                }
            },
            slider(i) {
                if(this.entries[i].media.slider) {
                    return { 
                        left:  this.entries[i].media.slider.left.url,
                        right: this.entries[i].media.slider.right.url,
                    }
                } else {
                    return
                }
            },
            sensitive(i) {
                if(this.entries[i].flag.sensitive) {
                    return true
                }
            },
            updateUserList(u) {
                this.userList = u
                this.userListDialog = true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

</style>